import { useTranslation } from 'react-i18next';
import CentrosBase from './CentrosBase';

const Hoteis = () => {

    const { t } = useTranslation();

    return (
        <CentrosBase centroNome={'HOTÉIS E GASTRONOMIA'} 
        centroDescricao={t('CentrosBase.hotelgastronomiaDescricao')} 
        tipo={'HOTEL'} 
        excludedCountries={['PERU', 'URUGUAI', 'CHILE']}/>
    );
};

export default Hoteis;